import apiPaths from '../api-paths';

export default {
  me() {
    return axios.get(`${ apiPaths.API }/onboarding/me`);
  },
};
